module.exports = ".dashed-border {\n  border: 1px dashed #dee2e6; }\n"